export default "__VITE_ASSET__CSsmRP2X__"